// extracted by mini-css-extract-plugin
module.exports = {"listD2":"ListD2Modal_listD2__0Xjyl"};